import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterTableDataType, SearchParamsType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
const { clinicId } = getConstants()
const { MastersApi } = api;
export const getMasterTableData = async (params:SearchParamsType): Promise<
  ResponseType<{items:MasterTableDataType[],totalRecords:number}>
> => {
  const result = await instance.post(`${MastersApi.getAllRateList}`,{...params,clinicId});
  return result.data;
};

export const uploadRateMasterFile = async (
  file: File
): Promise<ResponseType<string>> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("clinicId", `${clinicId}`);
  const result = await instance.post(
    `${MastersApi.uploadRateDataFile}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return result.data;
};

export const updateRateStatus = async (params: {
  priceListId: number;
  status: number;
}): Promise<ResponseType<string>> => {
  const result = await instance.post(
    `${MastersApi.updateRateStatus}?priceListId=${params.priceListId}&status=${params.status}`
  );
  return result.data;
};

export const deleteRateData = async (
  rateId: number
): Promise<ResponseType<string>> => {
  const result = await instance.delete(`${MastersApi.deleteRate}${rateId}`);
  return result.data;
};
